<template>
   <div class="container-fluid">
      <div class="row">
         <div class="col-xl-9 col-lg-8">
            <div class="card">
               <div class="card-header d-flex justify-content-between">
                  <div class="header-title">
                     <h4 class="card-title">Edit User Information</h4>
                  </div>
               </div>
               
               <div class="card-body">
                  <div class="new-user-info">
                     <form @submit="postData" method="post">
                        <div class="form-group" >
                           <label for="username">User Name:</label>
                           <input type="text" class="form-control" name="username" v-model.trim="posts.username" placeholder="Username" required>
                        </div>
                           
                        <div class="form-group">
                           <label for="merchant_code">Merchant Code</label>
                           <input type="text" class="form-control" name="merchant_code" v-model="posts.merchant_code" placeholder="Merchant Code" required> 
                        </div>      
                        
                        <div class="form-group">
                           <label for="role">User Role:</label>
                           <select class="form-control" id="role" v-model="posts.role_id" required>
                              <option value="1">Admin</option>
                              <option value="2">User</option>
                           </select>
                        </div>

                         <div class="form-group">
                           <label for="status">User Status:</label>
                           <b-form-select id="role" v-model="posts.role_id" required>
                              <option value="">Please select...</option>
                              <option v-for="role in roles" v-bind:value="role.id" v-bind:key="role.name">
                                 {{role.name}}
                              </option>
                           </b-form-select>
                        </div>

                        <div class="col-md-12 form-group">
                           <button type="submit" class="btn btn-primary float-right">Save</button>
                        </div>
                     </form>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

const config = require("../../../../../config");

Vue.use(VueAxios, axios);
export default {
   name:'UserEdit',
   data() {
      return {
         posts: {
            username: "",
            merchant_code: "",
            role_id:"",
            status:'',
            language:'en_US'
         },
         roles: null
      }
   },
   mounted: async function() {
      let id = this.$route.query.id;

      await this.getRoles();
      try {
         let response = await Vue.axios.get(config.api.URL + '/api/getUserInfo', { params: { id: id, m: this.$route.meta.uid } });
         let data = response.data.user_info;
         this.posts.username = data.username;
         this.posts.merchant_code = data.merchant_code;
         this.posts.role_id = data.role;
         this.posts.status = data.status
      } catch(error) {
         alert("Error: Retreive user data error.");
         console.log("Error: ", error);
      }
   },
   methods: {
      postData: async function(e) {
         e.preventDefault();
         let id = this.$route.query.id
         try {
            if(confirm("Are you sure you want to save this record?")) {
               await axios.post(config.api.URL + '/api/editUser', this.posts, { params: { id: id, m: this.$route.meta.uid } });
               alert("Record updated.");
               this.$router.push({path: '/user/list'});
            }
         } catch(error) {
            alert("Error: Update user error.");
            console.log("Error: ", error);
         }            
      },
      getRoles: async function() {
         try {
            const res = await axios.get(config.api.URL + '/api/roles', {
               params: {
                  m: this.$route.meta.uid
               }
            });
            
            this.roles = res.data;
         } catch(error) {
            console.log("Error: Unable to retrieve roles");
         }
      }
   }
}
</script>